<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>课堂投诉</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="老师：">
              <el-input name="tchId"
                        v-model="queryParam.tchKey" placeholder="ID/昵称" clearable></el-input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="学生：">
              <el-input name="uid"
                        v-model="queryParam.uidKey" placeholder="ID/昵称" clearable></el-input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="投诉人：">
              <el-input name="uid"
                        v-model="queryParam.adminKey" placeholder="昵称" clearable></el-input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="投诉理由：">
              <Select v-model="queryParam.remark" transfer clearable @on-change="search">
                <Option v-for="(item,index) in $constant.tchComplaintRemark"
                        :value="item.text" :key="index">{{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="是否处理：">
              <Select v-model="queryParam.status" transfer clearable @on-change="search">
                <Option v-for="item in $constant.yesNoNum"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Form-item label="老师课耗">
              <Select v-model="queryParam.subSalary" transfer clearable @on-change="search">
                <Option v-for="item in this.subSalaryEnum" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="学生返课时：">
              <Select v-model="queryParam.stdReturnNum" transfer clearable @on-change="search">
                <Option v-for="item in $constant.yesNoNum"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Form-item label="投诉日期:">
              <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <el-button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                       @click="search">搜索
            </el-button>
            <el-button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                       @click="exportData">导出
            </el-button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchList/complaint/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
    <ModifyComplaintModal :successCallback="search" @on-close="closeComplaintModal" :complaintRow="this.complaintRow"
                          :visible="showComplaintModal"></ModifyComplaintModal>
  </div>
</template>
<script>
import ShowImageCarousel from '../order/ShowImageCarousel'
import ModifyComplaintModal from './modal/ModifyComplaintModal'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {ShowImageCarousel, ModifyComplaintModal},
  data() {
    let $constant = this.$constant
    return {
      subSalaryEnum: [{code: 0, text: '正常计算'}, {code: 1, text: '不计算'}],
      complaintRemarkList: $constant.tchComplaintRemark,
      searchLoading: false,
      exportLoading: false,
      reload: 0,
        rankScoreSeq: 0,
      showImgModal: false,
      complaintRow: null,
      showComplaintModal: false,
      showImgList: [],
      studyAdviserList: [],
      queryParam: {
        tchKey: null,
        remark: '',
        subSalary: '',
        stdReturnNum: '',
        uidKey: null,
        adminKey: null,
        studyAdviserId: null
      },
      title: [
        {
          title: '课程信息',
          width: 130,
          render: (h, params) => {
            let row = params.row
            let lsnType = row.lsnType
            let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
            let courseType = row.courseType
            let courseTypeEnum = $constant.getEnum($constant.courseType, courseType)
            let cType = courseTypeEnum && courseTypeEnum.text
            if (cType) {
              cType = '课程类别:' + cType
            } else {
              cType = ''
            }
            return h('div', [
              h('p', row.bookLessonOpenedId),
              h('p', row.lessonTitle),
              h('p', {style: {'font-size': '12px', color: 'red'}}, cType),
              h('p', {style: {'font-size': '12px', color: '#2d8cf0'}}, '课程类型:' + (typeEnum && typeEnum.text))])
          }
        },
        {
          title: '老师ID/姓名',
          width: 180,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: (row.tchId != null ? row.tchId + '-' : '') + (row.tchName || ''),
              score: row.monthRankScore
            })
          }
        },
        {
          title: '学生ID、姓名',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.nickname)
          }
        },
        {
          title: '外管',
          width: 150,
          align: 'center',
          key: 'tchStudyAdviserName'
        },
        {
          title: '上课时间',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let children = [h('p', row.lessonTime)]
            if (row.liveUrl) {
              children.push(h('a', {on: {click: () => window.open(row.liveUrl)}}, '课程回放'))
            }
            return h('div', children)
          }
        },
        {
          title: '投诉人',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('p', row.adminName),
              h('p', row.createTime)])
          }
        },
        {
          title: '投诉理由',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.pics.length > 0) {
              return h('div', [
                h('span', row.remark),
                h('a', {on: {click: () => this.viewPic(row)}}, '查看附件')])
            }
            return h('div', [
              h('span', row.remark)])
          }
        },
        {
          title: '备注',
          width: 200,
          align: 'center',
          key: 'remarkOthers'
        },
        {
          title: '处理结果',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.status === 0) {
              return '待处理'
            }
            let hs = []
            if (row.stdNum > 0) {
              hs.push(h('p', '学生反课时:' + row.stdNum + '节'))
            }
            if (row.tchNum > 0) {
              hs.push(h('p', '老师额外扣除:' + row.tchNum + '￥'))
            }
            if (row.subSalary === 1) {
              hs.push(h('p', '老师扣除本节课耗'))
            }
            return h('div', hs)
          }
        },
        {
          title: '老师课耗',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.subSalary === 1) {
              return h('span', '不计算')
            }
            return h('span', '正常计算')
          }
        },
        {
          title: '处理人',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.status === 0) {
              return ''
            }
            return h('div', [
              h('p', row.adminDoName),
              h('p', row.updateTime)])
          }
        },
        {
          title: '处理意见',
          align: 'center',
          width: 150,
          key: 'doRemark'
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            if (params.row.status === 0) {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.onUpdateComplaint(params.row)
                    }
                  }
                }, '去处理')
              ])
            }
            // else if (params.row.status === 1) {
            //   return h('div', [
            //     h('a', {
            //       on: {
            //         click: () => {
            //           this.onUpdateComplaint(params.row)
            //         }
            //       }
            //     }, '修改')
            //   ])
            // }
          }
        }
      ]
    }
  },
  mounted: function () {
    let self = this
    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },
  created: function () {
  },
  methods: {
    search () {
      this.reload = new Date().getTime()
    },
        onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserPayList'}
      })
      window.open(href, '_blank')
    },
    viewPic (row) {
      this.showImgList = row.pics
      this.showImgModal = true
    },
    closeImgModal () {
      this.showImgList = []
      this.showImgModal = false
    },
    closeComplaintModal (val) {
      this.showComplaintModal = false
      this.complaintRow = {}
    },

    onUpdateComplaint (row) {
      this.showComplaintModal = true
      this.complaintRow = row
    },
    exportData (type) {
      this.exportLoading = true
      this.$http.get('/tchList/complaint/exportExcel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '老师投诉记录.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    atimeDateChange (value) {
      this.queryParam.startDate = value[0]
      this.queryParam.endDate = value[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchComplaintList.vue?6bf0a6b8